import React from "react"

import PageHeader from "../../components/page-header/page-header.component"
import Footer from "../../components/footer/footer.component"

import { BlogPostContainer } from "./blog-post.styles"

const BlogPostLayout = ({ children, ...props }) => (
  <React.Fragment>
    <PageHeader />
    <BlogPostContainer {...props}>{children}</BlogPostContainer>
    <Footer />
  </React.Fragment>
)

export default BlogPostLayout
